<template>
  <div class="my-store">
    <div class="store-name">{{ store_name || "McDonald's (Procurement)(S.Giza1)"}}</div>
    <div class="store-status"><span>{{ OpenText }}</span></div>
    <div class="store-starts" v-if="star_value">
      <van-rate v-model="star_value" allow-half void-icon="star" void-color="#eee" />
    </div>
    <div class="store-merchant">
      <div>Merchant Info</div>
    </div>
    <div class="store-text store-wapper">
      <div v-if="storeInfo.company_name" class="flex">
        <div class="store-label">Company :</div>
        <div class="flex1">{{storeInfo.company_name}} {{storeInfo.company_registration_no? '(' + storeInfo.company_registration_no + ')':''}}</div>
      </div>
      <div v-if="storeInfo.tel" class="flex">
        <div class="store-label">TEL :</div>
        <div class="flex1">{{storeInfo.tel}}</div>
      </div>
      <div v-if="storeInfo.email" class="flex">
        <div class="store-label">E-Mail :</div>
        <div class="flex1">{{storeInfo.email}}</div>
      </div>
      <div v-if="storeInfo.address" class="flex">
        <div class="store-label">Address :</div>
        <div class="flex1">{{storeInfo.address}}</div>
      </div>
      
      <div class="shop-tc-policy">
        <span @click="shopinfo('tc')"><van-icon name="share" /> T&C</span>
        <span @click="shopinfo('policy')"><van-icon name="share" /> Refund Policy</span>
      </div>

      
    </div>

    <div class="store-merchant">
      <div>Announcement</div>
    </div>
    <div class="store-text">
      <div>{{store_notice}}</div>
    </div>

    <div class="store-close-action">
      <van-icon @click="closeShow3" name="close" size="50" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    storeInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      OpenText: 'open',
      //营业状态
      open: {
        type: Boolean,
        default: true,
      },
      store_name: {
        type: String,
        default: ''
      },
      star_value: {
        //打星评分
        type: Number,
        default: 4.5
      },
      store_notice: {
        type: String,
        default: ''
      }
    }
  },
  created() {
    console.log('.................', this.storeInfo)
    this.initOpen()
  },
  methods: {
    initOpen() {
      this.open = this.storeInfo.is_show == 1
      this.star_value = parseInt(this.storeInfo.level)
      this.store_notice = this.storeInfo.announce
      this.store_name = this.storeInfo.title
      if (!this.open) {
        this.OpenText = 'close'
      }
    },
    closeShow3() {
      this.$emit('evtCloseMyStore')
    },
    shopinfo(attr){
      const url = {
        path: "/shop/index",
        query: {storeid: this.storeInfo.id, name:attr}
      };
      this.$router.push(url);
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../assets/css/common.less');
.my-store {
  padding: 0 20px;
  text-align: center;
}

.store-name {
  font-size: @size18;
  margin: 30px 0 10px 0;
}

.store-status {
  margin: 10px 0;

  span {
    padding: 2px 5px;
    font-size: @size12;
    background-color: green;
    border-radius: 3px;
  }
}

.store-starts {
  margin: 10px 10px;
}

.store-merchant {
  margin: 20px 0;
  width: 100%;
  height: 36px;
  line-height: 36px;
  text-align: center;
  position: relative;

  div:before,
  div:after {
    position: absolute;
    background: #ccc;
    content: '';
    height: 1px;
    top: 50%;
    width: 80px;
  }

  div:before {
    left: -5px;
  }

  div:after {
    right: -5px;
  }
}

.store-wapper {
  line-height: 20px;
  text-align: left;
  .shop-tc-policy{
    margin: 18px auto;text-align: center;color: #80d7ff;font-weight: bold;
    span{
      margin: 0 10px;
    }
  }
}
.store-text {
  font-size: @size14;
  line-height: 18px;
  .store-label{
    flex-basis: 70px;
  }
  .store-announcement {
    margin: 20px 0 10px 0;
    font-size: 20px;
  }
}

.store-close-action {
  margin: 30px 0 0 0;
  text-align: center;
}
</style>

